// libs
import React, { memo, useEffect } from 'react';

// helpers
import { getVPConfig } from './helpers';

// styles
import { Container, ImageContainer, Img } from './styles';
import sanitizeHTML from 'shared/helpers/utils/sanitizeHTML';

function VPErrorScreen() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const config = getVPConfig();

  return (
    <Container>
      <ImageContainer>
        <Img src={config.error_img_url} />
      </ImageContainer>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(config.attributed_title) }} />
      <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(config.error_msg) }} />
    </Container>
  );
}

export default memo(VPErrorScreen);
